import {apiService} from '../apiService';

export const approvalStagesService = apiService.injectEndpoints({
    endpoints: (builder) => ({

        /* ---------- STAGES ---------- */
        getApprovalStages: builder.query({
            query: (formId) => ({url: `/form-approvals/${formId}/stages`}),
            providesTags: (_result, _err, formId) => [
                `ApprovalStage-STAGES-${formId}`
            ],
        }),
        createApprovalStage: builder.mutation({
            query: ({
                        formId,
                        stage
                    }) => ({
                url: `/form-approvals/${formId}/stages`,
                method: 'post',
                data: stage,
            }),
            invalidatesTags: (_r, _e, {formId}) => [
                `ApprovalStage-STAGES-${formId}`
            ],
        }),
        updateApprovalStage: builder.mutation({
            query: ({
                        formId,
                        stageId,
                        stage
                    }) => ({
                url: `/form-approvals/${formId}/stages/${stageId}`,
                method: 'put',
                data: stage,
            }),
            invalidatesTags: (_r, _e, {
                formId,
                stageId
            }) => [
                `ApprovalStage-${stageId}`,
                `ApprovalStage-STAGES-${formId}`
            ],
        }),
        deleteApprovalStage: builder.mutation({
            query: ({
                        formId,
                        stageId
                    }) => ({
                url: `/form-approvals/${formId}/stages/${stageId}`,
                method: 'delete',
            }),
            invalidatesTags: (_r, _e, {
                formId,
                stageId
            }) => [
                `ApprovalStage-${stageId}`,
                `ApprovalStage-STAGES-${formId}`
            ],
        }),

        /* ---------- APPROVALS ---------- */
        submitApproval: builder.mutation({
            query: ({
                        assignmentId,
                        status,
                        note
                    }) => ({
                url: `/form-approvals/${assignmentId}/approval`,
                method: 'post',
                data: {
                    status,
                    note
                },
            }),
            invalidatesTags: (_r, _e, {
                formId,
                employeeId
            }) => [
                `ApprovalStage-STAGES-${formId}`,
                `ApprovalStage-PERS-${employeeId}`,
            ],
        }),
        getApprovalsByApprovalPersonId: builder.query({
            query: ({
                        employeeId,
                        pageNumber = 1,
                        pageSize = 20
                    }) => ({
                url: `/form-approvals/employee/${employeeId}?pageNumber=${pageNumber}&pageSize=${pageSize}`
            }),
            providesTags: (_result, _err, {employeeId}) => [
                `ApprovalStage-PERS-${employeeId}`,
            ],
        }),
    }),
});

export const {
    useGetApprovalsByApprovalPersonIdQuery,
    useGetApprovalStagesQuery,
    useCreateApprovalStageMutation,
    useUpdateApprovalStageMutation,
    useDeleteApprovalStageMutation,
    useSubmitApprovalMutation,
} = approvalStagesService;
